export type Weeks = {
  weeks: number;
};

/**
 * Reads the week count out of a fixed lead time strategy's config.
 *
 * The two fixed strategies used to hold days, which left them needing a divisor
 * they had no way to choose: the admin form said only "Days:", so nothing
 * recorded whether a site had typed production days, calendar days, or a week
 * multiple. Every value on record turned out to be a multiple of seven, so the
 * config now holds what the admin meant and no conversion happens here at all.
 */
export function extractWeeks(input: Weeks): number {
  const { weeks } = input;

  if (!weeks) {
    throw new Error('"Weeks" object must define a non-zero "weeks"');
  }

  return weeks;
}
